import { Skeleton } from 'antd'
import React from 'react'


interface Props{
    loading?: boolean
    children?: React.ReactNode
}

const SkeletonTitle = ({loading, children}:Props) => {
  return (
    <>
    {loading? <Skeleton.Button active={true} size={"default"} />
    
    : children
    }
    </>

  )
}

export default SkeletonTitle